/**
 * Granulární práva (Role.prava) — vyhodnocuje API vrstva přes `requirePravo(...)`.
 * DOMÉNOVÉ PRAVIDLO (invariant 1): `finance.read` je klíč ke zdi kolem peněz —
 * role bez něj NIKDY nedostane žádné finanční pole (ceny, částky, marže, sazby)
 * v žádné odpovědi API. Vynucuje centrální serializace, ne jednotlivé endpointy.
 */
export const PRAVA = [
    'finance.read',
    'finance.write',
    'projekty.read',
    'projekty.write',
    'smlouvy.read',
    'smlouvy.write',
    'import.read',
    'import.write',
    // Zápis výkresů (Blok C): založení výkresu, nahrání/přepnutí verze.
    // Čtení výkresů kryje projekty.read (výkres je součást zakázky).
    'vykresy.write',
    'zmeny.kvalifikovat',
    // Vědomá finanční rozhodnutí (Blok D): „neseme sami" (náklad bez výnosu) a
    // potvrzení vědomé ztráty — podpis ředitele (wireframe 13 §3). Přípravář ho NEMÁ.
    'zmeny.schvalovat',
    'denik.write',
    'denik.sign',
    'admin.users',
    'admin.firma',
];
/**
 * Výchozí práva pro výchozí sadu rolí (šablona per firma, §0b — firmy si role
 * přejmenují/doplní; zeď kolem financí ale zůstává invariant API, ne názvu role).
 * Mistr je VĚDOMĚ bez finance.* (domena-zakazka §2: „nic mu neukazovat").
 * Dělník v systému není (SitePerson bez loginu, invariant 8).
 */
export const VYCHOZI_ROLE_PRAVA = {
    reditel: [...PRAVA],
    pripravar: [
        'finance.read',
        'finance.write',
        'projekty.read',
        'projekty.write',
        'smlouvy.read',
        'smlouvy.write',
        'import.read',
        'import.write',
        'vykresy.write',
        'zmeny.kvalifikovat',
    ],
    stavbyvedouci: [
        'finance.read',
        'projekty.read',
        'smlouvy.read',
        'import.read',
        'vykresy.write',
        'zmeny.kvalifikovat',
        'denik.write',
        'denik.sign',
    ],
    // Mistr výkresy jen ČTE (projekty.read) — revize PD nahrává kancelář/stavbyvedoucí.
    mistr: ['projekty.read', 'denik.write', 'denik.sign'],
    // Externí/omezené role — v POC bez přístupu k financím GD (TDI vidí jen výnosovou
    // úroveň — směrová zeď se řeší v Bloku D u Změn/ZL; do té doby žádné finance).
    tdi: ['projekty.read'],
    reklamacni_technik: ['projekty.read'],
    subdodavatel: [],
    investor: ['projekty.read'],
};
/**
 * ZEĎ OPRÁVNĚNÍ (invariant 1) — finanční pole, která NIKDY neopustí API směrem
 * k roli bez `finance.read`. Centrální serializace je odstraňuje do hloubky
 * z každé odpovědi (whitelist rolí s finance.read, ne per-endpoint výjimky).
 * Platí v modelu/API/exportech, ne jen v UI.
 */
export const FINANCNI_POLE = [
    // smlouvy & dodatky
    'cena',
    'procentoPozastavky',
    'platebniPodminky',
    'penale',
    // částky obecně (ZL, položky, tranše, protokoly…)
    'castka',
    'castkaPredani',
    'jednotkovaCena',
    'marze',
    // agregace stran Změny a rekapitulace VaN (Blok D)
    'vynos',
    'naklad',
    // kumulativy rekapitulace a čerpání limitů (defense-in-depth — endpointy jsou
    // za finance.read, ale zeď nesmí spoléhat na guard jednoho modulu)
    'vynosMin',
    'nakladMin',
    'objemVynos',
    'cerpaniAbsVynos',
    'cerpanoProcent',
    // přepočet podpisu dodatku (cena Díla + základ pozastávky)
    'puvodniCenaDila',
    'sumaDodatku',
    'novaCenaDila',
    'novyZakladPozastavky',
    // pozastávky
    'zaklad',
    'procento',
    // kalkulační sazby (invariant 7), hodiny a materiál vlastní kalkulace
    // (hodiny × sazba = mzdový náklad — izolace mezd, invariant 7)
    'sazbaKcH',
    'hodiny',
    'materialCastka',
    // rozpočet
    'plan',
    'skutecnost',
    // kontrolní součty importu
    'kontrolniSoucet',
];
//# sourceMappingURL=prava.js.map